import { get as getLocal, set as setLocal } from '@/lib/local-storage';
import { createContext } from 'react';

export type ColorMode = 'light' | 'dark';

export interface AppThemeState {
  isDarkMode: boolean;
  colorMode: ColorMode;
  setColorMode: (mode: ColorMode) => void;
}

export const setColorMode = (mode: ColorMode): void => {
  setLocal('color-mode', mode);
};

export const getColorMode = (): ColorMode | null => {
  return (getLocal('color-mode') as ColorMode) || null;
};

export const AppThemeContext = createContext<AppThemeState>({
  colorMode: 'light',
  isDarkMode: false,
  setColorMode: () => null,
});
